/**
 * Handles tab functionality and show more for gut health conversations section
 * @param {string} sectionId - The Shopify section ID
 * @param {number} initialCountMobile - Initial video count for mobile
 * @param {number} initialCountDesktop - Initial video count for desktop
 */
(function() {
  function initGutHealthConversations(sectionId, initialCountMobile, initialCountDesktop) {
    const section = document.querySelector(`#shopify-section-${sectionId}`);
    if (!section) return;

    const tabs = section.querySelectorAll('[data-tab]');
    const videoItems = section.querySelectorAll('[data-video-category]');
    const showMoreBtn = section.querySelector('[data-show-more]');
    
    const getIsMobile = () => window.innerWidth < 990;
    const getInitialCount = () => getIsMobile() ? initialCountMobile : initialCountDesktop;
    const getActiveTab = () => section.querySelector('.gut-health-conversations__tab--active')?.getAttribute('data-tab') || 'all';
    
    let visibleCount = getInitialCount();
    let wasMobileState = getIsMobile();

    function filterVideos(activeTab) {
      const matchingItems = Array.from(videoItems).filter(item => {
        const categoriesStr = item.getAttribute('data-video-category')?.trim().toLowerCase() || '';
        const categories = categoriesStr.split(',').map(c => c.trim()).filter(Boolean);
        return activeTab === 'all' || categories.includes(activeTab);
      });
      
      videoItems.forEach(item => item.classList.remove('gut-health-conversations__video-item--active'));
      
      matchingItems.slice(0, visibleCount).forEach(item => {
        item.classList.add('gut-health-conversations__video-item--active');
      });

      if (showMoreBtn) {
        showMoreBtn.classList.toggle('gut-health-conversations__show-more--hidden', matchingItems.length <= visibleCount);
      }
    }

    function switchTab(clickedTab) {
      const scrollY = window.scrollY;
      const tabValue = clickedTab.getAttribute('data-tab');
      
      visibleCount = getInitialCount();
      
      tabs.forEach(tab => {
        const isActive = tab === clickedTab;
        tab.classList.toggle('gut-health-conversations__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      
      filterVideos(tabValue);
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'auto' }));
      });
    }

    function handleShowMore() {
      visibleCount += getIsMobile() ? 5 : 6;
      filterVideos(getActiveTab());
    }

    function handleResize() {
      const nowMobile = getIsMobile();
      
      if (wasMobileState !== nowMobile) {
        visibleCount = getInitialCount();
        filterVideos(getActiveTab());
      }
      
      wasMobileState = nowMobile;
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        switchTab(tab);
      });
    });

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', handleShowMore);
    }

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 250);
    });

    section.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-open-video-popup]');
      if (trigger) {
        e.preventDefault();
        const popupId = trigger.getAttribute('data-open-video-popup');
        if (window.openVideoPopup) window.openVideoPopup(popupId);
      }
    });

    filterVideos('all');
  }

  if (typeof window !== 'undefined') {
    window.initGutHealthConversations = initGutHealthConversations;
  }
})();
